import {connect} from "react-redux";
import {mapStateToProps} from "../../store/helpers/mapState";
import {mapDispatchToProps} from "../../store/helpers/mapDispatch";
import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import {Button, DialogActions} from "@mui/material";
import QtMaterialButton from "../../components/QtMaterialButton";
import {useEffect, useState} from "react";
import {errorToast, successToast} from "../../helpers/Notification";
import {getError, getSuccessMessage} from "../../store/helpers/common_functions";



const QuestionAnswers = ({position,SubmitGeneralForm,id,onSuccess,answers,onClose}) => {
    const [questions, setQuestions] = useState([]);
    const [interviewQuestions, setInterviewQuestions] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const questions = position?.questions ??[];
        setQuestions(questions.map(q=>{

           const answer = answers.find(a=>a.questionId === q.id);

            return {...q,comment:answer?.comment??'',marks:answer?.marks,objectId:answer?.id};
        }));

        const newIntQ = answers.filter(v=>!v.questionId && interviewQuestions.filter(it=>it.objectId === v.id).length<=0).map(v=>({comment:v.comment,objectId:v.id,marks:v.marks,question:v.question,outOf:v.outOf}))
        setInterviewQuestions([
            ...interviewQuestions,
            ...newIntQ
        ])
    }, [position,answers]);


    const onSubmit= async ()=>{
        setLoading(true);
        const resp = await SubmitGeneralForm(`/api/recruit/answer/questions/${id}`,{questions:[
                ...questions,
                ...interviewQuestions,
            ],positionId:position.id});
        if(resp.status){
            successToast(getSuccessMessage(resp));
            if(typeof onSuccess === 'function'){
                onSuccess();
            }
        }else{
            errorToast(getError(resp));
        }
        setLoading(false);
    }


    return <div>
        <form onSubmit={e=>{
            e.preventDefault();
            onSubmit().then();
        }}>
            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell>Question</TableCell>
                            <TableCell align="right">Out of Marks</TableCell>
                            <TableCell align="right">Marks</TableCell>
                            <TableCell align="right">Comment</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {questions.map((row) => (
                            <TableRow
                                key={row.name}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                                <TableCell component="th" scope="row">
                                    {row.question}
                                </TableCell>
                                <TableCell align="right">{row.outOf}</TableCell>
                                <TableCell align="right">
                                    <input required={true} value={row.marks} onChange={e=>{
                                        row.marks = e.target.value;
                                        setQuestions([
                                            ...questions
                                        ])
                                    }} type={'number'} className={'w-100  border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring ease-linear transition-all duration-150'} placeholder={'Marks'}/>
                                </TableCell>
                                <TableCell align="right">
                                <textarea rows={2} value={row.comment} onChange={e=>{
                                    row.comment = e.target.value;
                                    setQuestions([
                                        ...questions
                                    ])
                                }} className={'w-full  border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring ease-linear transition-all duration-150'} placeholder={'Comment'}></textarea>

                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <div className={'flex justify-end mt-2 mr-2 mb-2'}>
                <QtMaterialButton type={'button'} onClick={()=>{
                    setInterviewQuestions([
                        ...interviewQuestions,
                        {
                            marks:"",
                            comment:""
                        }
                    ])
                }} variant={'contained'}>Add Interview Questions</QtMaterialButton>
            </div>
            {interviewQuestions.length > 0 && <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell>Question</TableCell>
                                <TableCell align="right">Out of Marks</TableCell>
                                <TableCell align="right">Marks</TableCell>
                                <TableCell align="right">Comment</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {interviewQuestions.map((row) => (
                                <TableRow
                                    key={row.name}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                    <TableCell component="th" scope="row">
                                        <input required={true} value={row.question} onChange={e=>{
                                            row.question = e.target.value;
                                            setQuestions([
                                                ...questions
                                            ])
                                        }} type={'text'} className={'w-100  border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring ease-linear transition-all duration-150'} placeholder={'Question'}/>

                                    </TableCell>
                                    <TableCell align="right">
                                        <input required={true} value={row.outOf} onChange={e=>{
                                            row.outOf = e.target.value;
                                            setQuestions([
                                                ...questions
                                            ])
                                        }} type={'number'} className={'w-100  border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring ease-linear transition-all duration-150'} placeholder={'Out of Marks'}/>
                                    </TableCell>
                                    <TableCell align="right">
                                        <input required={true} value={row.marks} onChange={e=>{
                                            row.marks = e.target.value;
                                            setQuestions([
                                                ...questions
                                            ])
                                        }} type={'number'} className={'w-100  border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring ease-linear transition-all duration-150'} placeholder={'Marks'}/>
                                    </TableCell>
                                    <TableCell align="right">
                                <textarea rows={2} value={row.comment} onChange={e=>{
                                    row.comment = e.target.value;
                                    setQuestions([
                                        ...questions
                                    ])
                                }} className={'w-full  border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring ease-linear transition-all duration-150'} placeholder={'Comment'}></textarea>

                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>}
            <DialogActions>
                <Button type={'reset'} color={'error'} onClick={()=>{
                    if(typeof onClose === 'function') {
                        onClose(false);
                    }
                }}>Cancel</Button>
                <QtMaterialButton loading={loading} type={'submit'} variant={'contained'}>Submit Answers</QtMaterialButton>
            </DialogActions>
        </form>
    </div>;
}

export default connect(mapStateToProps,mapDispatchToProps)(QuestionAnswers);